import { BLANK_TEMPLATE_ID } from 'api/eventTemplates';
import { userTimeZone } from 'utils/moment';
import { deleteCall, get, patch, post, put } from './';

const serializeAgenda = (agenda: Bizly.AgendaItem) => ({
    // TODO: Revisit this serializer and remove reference to old schedule array/objects
    id: agenda.id,
    addToInquiry: agenda.addToInquiry,
    attendees: agenda.attendees || 1,
    amenities: {
        av: agenda.avNeeds?.map((avo: Bizly.AgendaAVNeed) => avo.id) ?? [],
        foodAndBeverage:
            agenda.fbNeeds?.map((fbo: Bizly.AgendaFBNeed) => ({
                optionId: fbo.id,
                styleId: fbo.diningStyle ? fbo.diningStyle.id : null,
            })) ?? [],
    },
    end: agenda.end,
    name: agenda.name,
    roomSetup: agenda.setup && agenda.setup.id,
    start: agenda.start,
    startTime: agenda.startTime,
    endTime: agenda.endTime,
});

export const serializeDay = (day: Bizly.Day) => ({
    // TODO: Revisit this serializer and remove reference to old schedule array/objects
    ...day,
    guestrooms: day.guestrooms || [],
    agenda: day.agenda ? day.agenda.map((a: Bizly.AgendaItem) => serializeAgenda(a)) : [],
});

const serializeEvent = (event: Bizly.Event) => ({
    // TODO: Revisit this serializer and remove reference to old schedule array/objects
    ...event,
    schedule: event.schedule.map((day: Bizly.Day) => serializeDay(day)),
});

export const getEvents = (query: string = '') => {
    const url = `events${query ? `?${query}` : ''}`;

    return get(url).then(({ success, events, collaborators }) => ({
        success,
        events: events.map(serializeEvent),
        collaborators: collaborators ? Object.values(collaborators) : undefined,
    })) as Promise<{
        success: boolean;
        events: Bizly.Event[];
        collaborators?: Bizly.EventCollaborator[];
    }>;
};

export const createEvent = (event: Partial<Bizly.Event>) =>
    post('events', { templateId: BLANK_TEMPLATE_ID, timeZone: userTimeZone, ...event }) as Promise<{
        event: Bizly.Event;
    }>;

export const setEventTimeZone = (eventId: number | string, timeZone: string) =>
    patch(`events/${eventId}/time-zone`, { timeZone }) as Promise<{ success: boolean; event: Bizly.Event }>;

// Capacity is event-wide rather than per-parcel, so it saves here instead of riding along in the
// invite payload. `guestCap: null` turns the cap off.
export const updateEventGuestCap = (
    eventId: number,
    { guestCap, waitlistEnabled }: { guestCap: number | null; waitlistEnabled: boolean }
) =>
    put(`events/${eventId}/guest-cap`, { guestCap, waitlistEnabled }) as Promise<{
        success: boolean;
        event?: Bizly.Event;
    }>;

export const getEventsResources = (eventId: number) =>
    get(`events/${eventId}/resources`) as Promise<{ success: boolean; resources: Bizly.EventResource[] }>;

export const uploadEventResources = (eventId: number, file: Bizly.EventResource) =>
    post(`events/${eventId}/resources`, file) as Promise<{ resource: Bizly.EventResource }>;

export const deleteEventResource = (eventId: number, resourceId: number) =>
    deleteCall(`events/${eventId}/resources/${resourceId}`) as Promise<{ success: boolean }>;
